import { Outlet } from '@tanstack/react-router';

export function AppsLayout() {
  return <Outlet />;
}
